module.exports = __webpack_public_path__ + "static/media/22.9cb443b6.jpg";